<template>
    <div class="other-tenant-item-content other-tenant-call-situation">
        <span class="other-tenant-title">接口调用情况</span>
        <div class="call-situation-content">
            <div class="call-situation-content-box" v-for="(item) in callSituationList" :key="item.title">
                <div class="call-situation-content-item">
                    <img class="call-situation-content-img" :src="item.titleImg" width="14" height="14" alt="">
                    <span class="call-situation-content-title">{{item.title}}</span>
                </div>
                <div class="call-situation-content-data">{{dataList[item.count]}}
                    <img  class="call-situation-content-increase-count-arrow" v-if="judgePositive(dataList[item.increase])"
                        src="../../../../../assets/images/icon_shangshen_green.svg" width="8" height="8" alt="">
                    <img  class="call-situation-content-increase-count-arrow"
                        v-else src="../../../../../assets/images/icon_xiajiang_red.svg" width="8" height="8" alt="">
                    <span :class="[judgePositive(dataList[item.increase])?'situation-success':'situation-fail','situation-percentage']"
                    > {{dataList[item.percentage]}}</span>
                </div>
                <div>
                    <span class="call-situation-content-increase">环比增长</span>
                    <span class="call-situation-content-increase-count">{{dataList[item.increase]}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { formatNegative } from '../../../../../utils/common';
import { CALL_SITUATION_LIST } from '../otherTenantConst';
export default {
    data() {
        return {
            dataList: {},
            callSituationList: CALL_SITUATION_LIST
        };
    },
    methods: {
        dataProcess(lsit) {
            this.dataList = { ...lsit };
            this.callSituationList.forEach(item => {
                const { count, increase, percentage } = item;
                this.dataList[count] = this.dataList[count] ? (this.dataList[count]).toLocaleString() : 0;
                this.dataList[increase] = this.dataList[increase] ? (this.dataList[increase]).toLocaleString() : 0;
                this.dataList[percentage] = formatNegative(this.dataList[percentage]);
            });
        },
        judgePositive(data) {
            const value = data || 0;
            return value.toString().indexOf('-') === -1;
        }
    }
};
</script>
<style lang="less">
.other-tenant-call-situation{
    .call-situation-content{
        display: flex;
        justify-content:space-around;
    }
    .call-situation-content-box{
        width: calc((100% - 12px) / 3);
    }
    .call-situation-content-item{
        line-height: 12px;
    }
    .call-situation-content-img{
        vertical-align: middle;
    }
    .call-situation-content-title{
        margin-left: 6px;
        vertical-align: middle;
        font-family: 'PingFangSC-Regular', sans-serif;
        font-size: 13px;
        line-height: 13px;
        color: #666666;
    }
    .call-situation-content-data{
        margin: 14px 0 1px;
        line-height: 35px;
        font-size: 18px;
        font-family: 'PingFangSC-Semibold', sans-serif;
        font-weight: 600;
        color: #333333;
    }
    .call-situation-content-increase{
        margin-right: 2px;
        font-family: 'PingFangSC-Regular', sans-serif;
        font-size: 12px;
        color: #6a706d;
        line-height: 12px;
        font-weight: 400;
    }
    .call-situation-content-increase-count{
        vertical-align: middle;
        font-family: 'PingFangSC-Medium', sans-serif;
        font-size: 14px;
        color: #333333;
        line-height: 14px;
        font-weight: 500;
    }
    .situation-percentage{
        vertical-align: middle;
        font-family: 'PingFangSC-Semibold', sans-serif;
        font-size: 10px;
        line-height: 10px;
        font-weight: 600;
    }
    .call-situation-content-increase-count-arrow{
        vertical-align: middle;
        line-height: 14px;
    }
    .situation-success{
        color: #00c66b;
    }
    .situation-fail{
        color: #ff3c3c;
    }

}
</style>